import { InputHTMLAttributes, forwardRef } from 'react';
import { TextInput, Label } from '@atoms/index';
import { InlineErrorMessage } from '@atoms/Errors/InlineErrorMessage';
import { ErrorMessages } from '@types';

export interface TextInputMoleculeProps
  extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  labelClassName?: string;
  description?: string;
  errorPath?: string;
  errorMessages?: ErrorMessages[];
  maxLength?: number;
  subtext?: string;
}

export const TextInputMolecule = forwardRef<
  HTMLInputElement,
  TextInputMoleculeProps
>(({ label, labelClassName, description, ...props }, ref) => {
  const maxLength = props.maxLength ?? 100;

  return (
    <div className="body-1 my-4 flex flex-col gap-[8px]">
      <Label
        id={props.errorPath ?? props.id}
        htmlFor={props.id}
        text={label}
        className={labelClassName}
      />
      {props?.subtext !== undefined ? (
        <pre className="body-2 mb-6 whitespace-pre-wrap text-2xl font-light">
          {props.subtext}
        </pre>
      ) : null}
      {description ? (
        <div className="text-text-body text-bodyLg font-normal leading-[28.5px]">
          {description}
        </div>
      ) : null}

      <InlineErrorMessage
        path={props.errorPath}
        messages={props.errorMessages}
      />
      <TextInput
        {...props}
        ref={ref}
        aria-label={label}
        maxLength={maxLength}
      />
    </div>
  );
});

TextInputMolecule.displayName = 'TextInputMolecule';
